import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { ArrowLeftIcon } from "@heroicons/vue/24/solid";


export default /*#__PURE__*/_defineComponent({
  __name: 'RestoreButton',
  props: {
    // items: {
    //     type: Object,
    //     required: true,
    // },
},
  setup(__props) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("button", {
    onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('click'))),
    class: "mx-1 p-[6px] border border-transparent rounded shadow-[0_0_4px_0px_rgb(17,24,39,0.25)] bg-green-600 hover:bg-green-500 active:bg-green-700 focus:outline-none focus:ring-1 focus:ring-offset-1 focus:ring-red-400"
  }, [
    _createVNode(_unref(ArrowLeftIcon), {
      class: "h-5 w-5 text-white",
      "aria-hidden": "true"
    })
  ]))
}
}

})